import { Component, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Applications } from '../../interfaces/application';
import { ApplicationsService } from '../applications.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ScrollbarModule } from '@michelin/theme';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-app-applications-modal',
  templateUrl: './applications-modal.component.html',
  styleUrls: ['./applications-modal.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    ScrollbarModule,
    MatOption,
    MatDialogActions,
    MatButton
  ]
})
export class ApplicationsModalComponent {
  dialogRef = inject<MatDialogRef<ApplicationsModalComponent>>(MatDialogRef);
  data = inject<Applications>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  private readonly applicationService = inject(ApplicationsService);

  applicaitons: Applications[];
  subscription: Subscription;
  updatedApp: boolean;

  newData: Applications;
  status = this.formBuilder.group({
    value: ['', Validators.required]
  });

  onNoClick(): void {
    this.updatedApp = false;
    this.dialogRef.close(this.updatedApp);
  }
  onAction() {
    this.newData = {
      name: this.data.name,
      status: this.status.value.value
    };

    this.applicationService.updateApplication(this.data.id, this.newData).subscribe(() => {});
    this.updatedApp = true;
    this.dialogRef.close(this.updatedApp);
  }
}
